import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const DevKitAssetsPage = loadable(() =>
  withDefaultLoaderModifiers(import("./DevKitAssetsPage"))
);
